// templates/SmallInfoBoxTemplate.ts
import { BaseTemplate } from "./BaseTemplate";
export class SmallInfoBoxTemplate extends BaseTemplate {
    constructor(action) {
        super(action);
    }
    render() {
        var _a, _b;
        // IMPORTANT: use the base container (engage-template)
        this.container.classList.add("engage-smallinfobox");
        // Determine location
        const location = ((_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.Location) || "bottom-right";
        // Add predefined position class
        this.container.classList.add(`engage-${location}`);
        // Insert HTML content
        this.container.innerHTML = this.getProcessedHtml();
        this.executeScripts(this.container);
        // Mount to body
        this.mountToBody();
        // Hide login elements if user is logged in
        this.applyUserState();
        // Apply offsets (WITHOUT transform)
        this.applyOffsets();
        // Apply transition
        this.applyTransitionIn();
        // Setup close
        this.setupCloseHandler();
    }
    applyOffsets() {
        var _a;
        const opts = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat;
        if (!opts)
            return;
        const horizontalOffset = opts.HorizontalOffset;
        const verticalOffset = opts.VerticalOffset;
        // only override position classes if offsets are explicitly provided
        if (horizontalOffset !== undefined && horizontalOffset !== null
            && verticalOffset !== undefined && verticalOffset !== null) {
            this.container.classList.remove("engage-top-left", "engage-top-right", "engage-bottom-left", "engage-bottom-right");
            this.container.style.position = "fixed";
            this.container.style.left = `${horizontalOffset}%`;
            this.container.style.top = `${verticalOffset}%`;
        }
        // otherwise the position class (e.g. engage-bottom-right) handles placement
    }
}
